"use client";

import { useEffect, useState } from "react";
import { Dialog } from "./Dialog";
import { t } from "i18next";
import type { LatLngLiteral, LeafletMouseEvent, Map } from "leaflet";
import { Button } from "../ui";
import { MapIcon } from "lucide-react";
import { LeafletMap } from "../maps/leaflet-map.lazy";
import type { OSMRes } from "../maps/leaflet-location-search";

export type LocationPickerProps = {
  latitude?: number;
  longitude?: number;
  onChange?: (coords: LatLngLiteral | null) => void;
};

export default function LocationPickerDialog({
  latitude,
  longitude,
  onChange,
}: LocationPickerProps) {
  const center: [number, number] =
    latitude && longitude ? [latitude, longitude] : [51.505, -0.09];
  const [dialog, setDialog] = useState(false);
  const [marker, setMarker] = useState<[number, number]>(center);

  function onLeafletClickHandler(_: Map, e: LeafletMouseEvent) {
    onChange?.({ lat: e.latlng.lat, lng: e.latlng.lng });
    setMarker([e.latlng.lat, e.latlng.lng]);
  }

  function onLocationSearchSelect(map: Map, res: OSMRes) {
    map.flyTo([parseFloat(res.lat), parseFloat(res.lon)], 17);
  }

  useEffect(() => {
    if (latitude && longitude) {
      setMarker([latitude, longitude]);
    }
  }, [latitude, longitude]);

  return (
    <Dialog
      title={t("map.selectLocation")}
      description={t("map.selectLocationDescription")}
      open={dialog}
      onOpenChange={setDialog}
      width="90vw"
      children={
        <>
          <LeafletMap
            center={center}
            zoom={13}
            markers={[marker]}
            onClick={onLeafletClickHandler}
            onLocationSearchSelect={onLocationSearchSelect}
          />

          <div className="mt-4 text-sm text-gray-500">
            Latitude: {latitude ?? "N/A"}, Longitude: {longitude ?? "N/A"}
          </div>
        </>
      }
      trigger={
        <Button variant="outline" onClick={() => setDialog(true)}>
          <MapIcon />
        </Button>
      }
    />
  );
}
